<template>
    <div class="agenda-topic-message-container" :class="{ 'mr-5': !reply, 'ml-5': reply && level < 5 }">
        <div class="agenda-topic-message d-flex justify-space-between mr-5 my-3">
            <v-avatar size="26" class='title-avatar flex-shrink-1 align-self-center'>
                <img v-if="message.photo_url" :src="message.photo_url" :alt="message.created_by_full_name">
                <v-icon :title="message.created_by_full_name" v-else>fas fa-user-circle</v-icon>
            </v-avatar>
            <div class="pl-2 ma-0 flex-shrink-1 flex-grow-1">
                <div class="agenda-topic-message--meta">
                    <strong>{{ message.created_by_full_name }}</strong>
                    <span class="text-muted mx-2"> &bull; {{ stamp }}</span>
                    <span class="agenda-topic-message--student mr-2" v-if="message.student_id">
                        <a @click="$router.push({ path: `/StudentProfile/${message.student_id}` })">
                            @{{ message.student_full_name }}
                        </a>
                    </span>
                    <v-icon v-if="message.private_flag" color="#050F2D" size="12">fas fa-lock</v-icon>
                    <div v-if="!disabled" class="d-flex ml-2">
                        <fe-icon-btn size="12" @click="$emit('reply', message)" useIcon="far fa-reply" class="agenda-topic-message--btn" data-test="topic-reply-btn"></fe-icon-btn>
                        <fe-icon-btn size="12" :disabled="!editable" @click="$emit('edit', message)" useIcon="far fa-edit" class="agenda-topic-message--btn" data-test="topic-edit-btn"></fe-icon-btn>
                        <fe-icon-btn size="12" :disabled="!editable" @click="$emit('delete', message)" useIcon="far fa-trash" class="agenda-topic-message--btn" data-test="topic-delete-btn"></fe-icon-btn>
                    </div>
                </div>
                <div class="agenda-topic-message--body" v-safe-html="message.value" />
            </div>
        </div>

        <topic-message
            v-for="msg in children"
            :key="`topic-message-${msg.id}`"
            :message="msg"
            :messages="messages"
            :level="level+1"
            :reply="true"
            :disabled="disabled"
            @reply="$emit('reply', $event)"
            @edit="$emit('edit', $event)"
            @delete="$emit('delete', $event)"
        />
    </div>
</template>

<script>
    import Vuex, {mapState} from 'vuex'

    export default {
        name: 'TopicMessage',
        props: {
            message: { type: Object, required: true },
            messages: { type: Array, required: true },
            reply: { type: Boolean },
            level: { type: Number, default: 0 },
            disabled: { type: Boolean, default: false }
        },
        data () {
            return {
                menu: false
            }
        },
        computed: {
            ...mapState('global', ['sessionUser']),
            editable () { return this.sessionUser.user.id == this.message.created_by && !this.children.length },
            stamp () { return this.$dayjs(this.message.created).format("MMM D") },
            children () { return this.messages.filter(itm => itm.parent_message_id == this.message.id) }
        },
        methods: { },
        watch: { }
    }
</script>

<style lang="scss">
    .agenda-topic-message {
        min-height: 40px;
        align-items: flex-start;
        &--body, &--meta, &--student {
            font-size: 12px;
            .ec-fe-lib .v-application & p { margin: 0; }
        }
        &--meta {
            display: flex;
            align-items: center;
            min-height: 24px;
        }
        &--btn {
            .v-btn {
                margin: 0;
                padding: 0;
                height: 24px;
                width: 24px;
            }
        }
    }
</style>
